<template>
  <div>
    <bs-card class="card-info" :icon="resourceState.icon" :label="$tc('labels.' + camelToSnake(singular($options.name)), 0)">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create" v-if="auth.can['edit_users']">{{ $t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.create') }) }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="4">
        <template v-slot:thead>
          <tr>
            <bs-th :label="$t('labels.name')" :sortable="resourceState.sort" :col="'name'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.phone')"></bs-th>
            <bs-th :label="$t('labels.email')" :sortable="resourceState.sort" :col="'email'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.role')" @click="applySort"></bs-th>
            <th></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>
            <span class="d-flex">
              <span :class="'sm-swatch bg-' + r.color"></span>
              <span class="pl-2">{{ r.name }}</span>
            </span>
          </td>
          <td>{{ r.number }}</td>
          <td>{{ r.email }}</td>
          <td>{{ r.role ? r.role.name : '' }}</td>
          <td class="t3">
            <bs-action :icon="['fal', 'sign-in']" class="btn-warning" :tip="$t('labels.action_resource', { action: $t('labels.assume'), resource: $t('labels.user') })" @click="assumeUser(r.id)"></bs-action>
            <bs-action v-if="auth.can['edit_users']" :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
            <bs-action v-if="auth.can['edit_users']" :icon="['fal', 'trash']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <div class="row">
            <div class="col-6">
              <tuxedo-input :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error" />
            </div>
            <div class="col-6">
              <tuxedo-select :name="'role_id'" :label="$t('labels.role')" v-model="resource.role_id" :options="roles" :insistReturn="'id'" :insistLabel="'name'" :error="slotProps.error" />
            </div>
          </div>
          <tuxedo-input :name="'number'" :label="$t('labels.phone')" v-model="resource.number" :error="slotProps.error" />
          <tuxedo-input :type="'email'" :name="'email'" :label="$t('labels.email')" v-model="resource.email" :error="slotProps.error" />
          <tuxedo-input :type="'password'" :name="'password'" :label="$t('labels.password')" :help="$t('messages.password_not_required')" v-model="resource.password" :error="slotProps.error" />
          <select-field :name="'color'" :label="$t('labels.color')" v-model="resource.color" :error="slotProps.error">
            <option value="blue">Blue</option>
            <option value="indigo">Indigo</option>
            <option value="purple">Purple</option>
            <option value="pink">Pink</option>
            <option value="red">Red</option>
            <option value="light-red">Light Red</option>
            <option value="orange">Orange</option>
            <option value="light-orange">Light Orange</option>
            <option value="yellow">Yellow</option>
            <option value="light-yellow">Light Yellow</option>
            <option value="green">Green</option>
            <option value="teal">Teal</option>
            <option value="cyan">Cyan</option>
          </select-field>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: $t('labels.user') }) }}
      </bs-form>
    </bs-modal>
    <bs-modal :name="'assignClients'" :label="$t('labels.assign_clients')">
      <bs-form :submit="$t('labels.assign')" @submit="assignClients">
        <template v-if="!dataLoading">
          <bs-badge class="clickable"
                    v-for="client in clients"
                    :key="'c' + client.id"
                    :class="assignedClients.includes(client.id) ? 'badge-secondary' : 'badge-light'"
                    @click="toggle(client.id)"
          >{{ client.name }}</bs-badge>
        </template>
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Users',
  data () {
    return {
      loading: false,
      dataLoading: false,
      activeId: null,
      assignedClients: [],
      resource: {
        name: '',
        email: '',
        number: null,
        role_id: null,
        password: '',
        password_confirmation: '',
        color: null
      }
    }
  },
  mounted () {
    this.index(this.page)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resourceStore: state => state.usersStore,
      resourceState: state => state.usersState,
      roles: state => state.roles.data,
      clients: state => state.clientsState,
      resources: state => state.users,
      submitting: state => state.submitting
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    }
  },
  methods: {
    ...mapMutations([
      'pushState'
    ]),
    assumeUser (id) {
      this.$store.dispatch('assumeUser', { id: id })
    },
    assign (o) {
      this.activeId = o.id
      this.assignedClients = o.clients
      this.dataLoading = true
      this.$modal.show('assignClients')
      this.$store.dispatch('index', { collection: 'Clients', params: { all: true } }).then(() => {
        this.dataLoading = false
      })
    },
    toggle (id) {
      if (this.assignedClients.includes(id)) {
        this.assignedClients = this._.remove(this.assignedClients, (n) => {
          return n === id
        })
      } else {
        this.assignedClients.push(id)
      }
    },
    assignClients () {
      this.$store.dispatch('update', { path: 'user-clients', collection: this.$options.name, resource: { id: this.activeId, clients: this.assignedClients } }).then(() => {
        this.$modal.hide('assignClients')
      })
    },
    applySort (val) {
      this.pushState({ view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    index (page, count) {
      if (page) this.pushState({ view: this.$options.name, key: 'page', data: page })
      if (count) this.pushState({ view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$store.commit('axiosError', null)
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
